import '.ea{font-size:1.125rem;}.ssr-plugin'
import '.e0{line-height:1.75rem;}.ssr-plugin'
import '.hy{text-decoration:none;}.ssr-plugin'
import '.ft{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="ea e0"
    >
      {translations.privacySubtitle}{' '}
      <a className="hy ft"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="hy ft"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
